import React, { useEffect } from "react";
import Aos from "aos";
import img1 from "../../../assets/Images/Banner/1.jpg";
import img2 from "../../../assets/Images/Banner/2.jpg";
import img3 from "../../../assets/Images/Banner/3.jpg";
import info from "../../../assets/Images/Banner/AWswee.png";

import { Image } from "react-bootstrap";

import "aos/dist/aos.css";
const HeaderBanner = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <div id="Home">
        <div className="main-banner main-bg-color position-relative p-40-0 d-flex align-items-center">
          <div className="container">
            <div className="margin-0-auto max-width-1000">
              <p className="main-light-text-color pill d-inline transform-capitalize pill-light">App devloper</p>
              <h1 className="main-light-text-color font-cormorant f-80 typewriter m-20-0">
                I am only passionately curious.
              </h1>
              <p className="main-light-text-color f-18 lh-35">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In cursus fringilla nunc, a fermentum odio vehicula pretium. Nullam ullamcorper dui id felis consectetur condimentum. Praesent ornare sem efficitur, luctus dui et, fermentum augue. Proin at auctor lacus. Nullam congue, lacus at rhoncus consectetur, diam ante vestibulum nibh, quis consectetur elit tortor vel lectus.
              </p>
            </div>
            <div className="position-absolute banner-img-1 width-400">
              <div className="position-relative">
                <Image
                  className="d-block img-fluid mx-auto img-border border-radius "
                  src={img1}
                />
                <div className="hover-show position-relative width-400">
                  <Image
                    className="d-block img-fluid mx-auto  "
                    src={info}
                  />
                  <div className="position-absolute info-img-text width-300">
                    <p className="f-18">Aisya Arooh </p>
                    <p className="f-16">Developer </p>
                    <p className="f-14 main-light-text-color">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="position-absolute banner-img-2 width-400">
              <div className="position-relative">
                <Image
                  className="d-block img-fluid mx-auto img-border border-radius "
                  src={img2}
                />
                <div className="hover-show position-relative width-400">
                  <Image
                    className="d-block img-fluid mx-auto  "
                    src={info}
                  />
                  <div className="position-absolute info-img-text width-300">
                    <p className="f-18">Aisya Arooh </p>
                    <p className="f-16">Developer </p>
                    <p className="f-14 main-light-text-color">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="position-absolute banner-img-3 width-400">
              <div className="position-relative">
                <div className="hover-show position-relative width-400">
                  <Image
                    className="d-block img-fluid mx-auto  "
                    src={info}
                  />
                  <div className="position-absolute info-img-text width-300">
                    <p className="f-18">Aisya Arooh </p>
                    <p className="f-16">Developer </p>
                    <p className="f-14 main-light-text-color">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                  </div>
                </div>
                <Image
                  className="d-block img-fluid mx-auto img-border border-radius "
                  src={img3}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderBanner;
